import { styled, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useSearchResult } from "../../../hooks/indicatorHooks";
import { LayerSearchFormValues, LayerProperties } from "../../../types";
import { LayerSearchResultItem } from "./LayerSearchResultItem";

interface Props {
  config: string;
  layerProperties: LayerProperties[];
  selection: LayerSearchFormValues;
}

export function LayerSearchResults(props: Props) {
  const { config, layerProperties, selection } = props;
  const { t } = useTranslation();

  const { data: results } = useSearchResult(selection, config, layerProperties);

  return (
    <>
      {results &&
        results.features.map((feature) => (
          <LayerSearchResultItem
            key={feature.id}
            config={config}
            selection={selection}
            feature={feature}
            layerProperties={layerProperties}
          />
        ))}
      {results && results.features.length < 1 && (
        <StyledNoResults>{t("label.noResults")}</StyledNoResults>
      )}
    </>
  );
}

const StyledNoResults = styled(Typography)`
  width: 100%;
  text-align: center;
  margin: ${({ theme }) => theme.spacing(2, 1)};
`;
